import {GET_CURRENT_WEATHER_SUCCESS} from "../../reducers/weatherReducer";

export const getCurrentWeatherSuccess = (currentWeather) =>{
    return {
        type: GET_CURRENT_WEATHER_SUCCESS,
        payload: {currentWeather}
    }
}